import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ColumnSavingButtonsWrapper" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "NavigatorButton ColumnSavingButton",
      title: "Save current table column order",
      disabled: _ctx.disableSaveButton,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveColumnOrder && _ctx.saveColumnOrder(...args)))
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("i", { class: "lnr-floppy-disk" }, null, -1 /* CACHED */)
    ]))], 8 /* PROPS */, _hoisted_2),
    _createElementVNode("button", {
      class: "NavigatorButton ColumnSavingButton",
      title: "Revert back to default table column order",
      disabled: _ctx.disableResetButton,
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetColumnOrder && _ctx.resetColumnOrder(...args)))
    }, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("i", { class: "ResetIcon lnr-redo2" }, null, -1 /* CACHED */)
    ]))], 8 /* PROPS */, _hoisted_3)
  ]))
}